import styled from "styled-components";

import { media } from "constants/media";

export const Wrapper = styled.div<{ reverse: boolean }>`
    border-radius: 160px;
    height: 168px;
    overflow: hidden;
    position: absolute;
    right: -100px;
    top: -160px;
    transform: ${({ reverse }) => (reverse ? "scaleX(-1)" : null)};
    width: 400px;
    z-index: -1;

    ${media.mdUp} {
        border-radius: 400px;
        height: 332px;
        margin-left: auto;
        margin-right: auto;
        right: -300px;
        top: 60px;
        width: 650px;

        &::before {
            //stylelint-disable
            background: linear-gradient(
                90deg,
                rgba(255, 255, 255, 0.2) 0%,
                rgba(255, 255, 255, 0) 100%
            );
            //stylelint-enable
            border-radius: 400px;
            content: "";
            display: block;
            height: 332px;
            position: absolute;
            right: -175px;
            width: 660px;
            z-index: 1;
        }
    }

    ${media.lgUp} {
        height: 480px;
        right: -450px;
        transform: ${({ reverse }) => (reverse ? "scaleX(-1)" : null)};
        width: 900px;

        &::before {
            height: 480px;
            width: 900px;
        }
    }

    ${media.xlUp} {
        right: -400px;
        width: 900px;

        &::before {
            right: 0;
        }
    }
`;

export const NewWrapper = styled.div``;
